import jwtDecode from "jwt-decode";

import logoWhite from '../../images/Motili-Logo-White.svg';
import airAndHeatDoneRightLogo from '../../images/air_and_heat_done_right_white.png';
import motiliForAigLogo from '../../images/motili_for_aig_white_logo.png';

module.exports = {
    isAAHDR,
    isContractor,
    isAIG,
    getBusinessChannelSpecificValues,
    determineHeaderLogo,
    formatCurrency
};

/**
 *
 * @return {boolean}
 */
function isAAHDR() {
    const hostName = window.location.hostname;
    if (hostName.includes('airandheatdoneright')) {
        return true;
    }
    const href = window.location.href;
    if (!href) {
        return false;
    }
    try {
        const token = href.split('/').pop();
        const decoded = jwtDecode(token);
        if (decoded && decoded.data && decoded.data.businessChannelName === 'AIR_AND_HEAT_DONE_RIGHT') {
            return true;
        }
    }
    catch (err) {
        // Nothing to do
    }

    return false;
}

/**
 *
 * @param contractorTypeId
 * @return {boolean}
 */
function isContractor(contractorTypeId) {
    return !!contractorTypeId && contractorTypeId === 'CT_CONTRACTOR';
}

/**
 *
 * @return {boolean}
 */
function isAIG() {
    const href = window.location.href;
    if (!href) {
        return false;
    }
    try {
        const token = href.split('/').pop();
        const decoded = jwtDecode(token);
        if (decoded && decoded.data && decoded.data.businessChannelName === 'AIG') {
            return true;
        }
    }
    catch (err) {
        // Nothing to do
    }

    return false;
}

/**
 *
 * @return {*}
 */
function getBusinessChannelSpecificValues(contactType) {
    const href = window.location.href;
    let businessChannel = isAAHDR() ? 'AIR_AND_HEAT_DONE_RIGHT' : null;
    let _contactType = contactType;

    if (href) {
        try {
            const token = href.split('/').pop();
            const decoded = jwtDecode(token);
            if (!businessChannel) {
                businessChannel = decoded && decoded.data ? decoded.data.businessChannelName : 'MOTILI';
            }
            if (!_contactType) {
                _contactType = decoded.sub;
            }
        }
        catch (err) {
            // Nothing to do
        }
    }
    switch (businessChannel) {
        case 'AIG':
            if (_contactType === 'CONTRACTOR' || _contactType === 'CT_CONTRACTOR') {
                return {
                    businessChannel: businessChannel,
                    businessChannelName: 'MOTILI',
                    phone: '844-713-0435',
                    phoneNationalAccount: '844-713-0435',
                    email: 'customer.support@motili.com',
                    supportEmail: 'customer.support@motili.com',
                    logo: motiliForAigLogo
                };
            }
            return {
                businessChannel: 'MOTILI_FOR_AIG',
                businessChannelName: 'MOTILI FOR AIG',
                phone: '844-713-0435',
                phoneNationalAccount: '844-713-0435',
                email: 'customer.support@motili.com',
                supportEmail: 'customer.support@motili.com',
                logo: motiliForAigLogo
            };
        case 'AIR_AND_HEAT_DONE_RIGHT':
            if (_contactType === 'CONTRACTOR' || _contactType === 'CT_CONTRACTOR') {
                return {
                    businessChannel: businessChannel,
                    businessChannelName: 'MOTILI',
                    phone: '800-669-9656',
                    phoneNationalAccount: '877-959-7916',
                    email: 'info@motili.com',
                    supportEmail: 'customer.support@motili.com',
                    logo: airAndHeatDoneRightLogo
                };
            }
            return {
                businessChannel: businessChannel,
                businessChannelName: 'AIR & HEAT DONE RIGHT',
                phone: '833-371-7706',
                phoneNationalAccount: '833-371-7706',
                email: 'cs@airandheatdoneright.com',
                supportEmail: 'cs@airandheatdoneright.com',
                logo: airAndHeatDoneRightLogo

            };
        case 'MOTILI':
        default:
            return {
                businessChannel: businessChannel,
                businessChannelName: 'MOTILI',
                phone: '800-669-9656',
                phoneNationalAccount: '877-959-7916',
                email: 'info@motili.com',
                supportEmail: 'customer.support@motili.com',
                logo: logoWhite
            };
    }
}

function determineHeaderLogo() {
    const brandingData = getBusinessChannelSpecificValues();
    if (brandingData) {
        return brandingData.logo;
    }

    return logoWhite;
}

function formatCurrency(
    amount,
    currency = 'USD',
    minimumFractionDigits = 2
) {
    const currencyFormat = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
    });
    return currencyFormat.format(amount);
}



// WEBPACK FOOTER //
// ./src/app/utils/Utils.js